export default __webpack_public_path__ + "static/media/adidas.82660410.png";